import { Component } from '@angular/core'

@Component({
  selector: 'se-po-merge-persona-modal-docs',
  templateUrl: './merge-persona-modal-docs.component.html',
  styleUrls: ['./merge-persona-modal-docs.component.scss'],
  standalone: false,
})
export class MergePersonaModalDocsComponent {
  public models: string[]
  public headers: any = {
    MergePersonaModalComponent: [
      'Property',
      'Type',
      'Description',
    ]
  }

  public rows: any = {
    MergePersonaModalComponent: [
      {
        Property: '@Output() personaMerged',
        Type: 'Persona',
        Description: 'Given persona merged into the kept persona',
      }
    ]
  }

  constructor() {
    this.models = Object.keys(this.headers)
  }
}
